import { useState } from "react"

import { useQuery } from "@tanstack/react-query"
import { Check, ChevronDown } from "lucide-react"

import { getUnits } from "@/api/getUnits.ts"
import { cn } from "@/lib/utils.ts"

import { Button } from "./ui/button.tsx"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command.tsx"
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover.tsx"

export default function UnitSelector({
  value,
  onChange,
}: {
  value: number
  onChange: (id: number) => void
}) {
  const [open, setOpen] = useState<boolean>(false)
  const { data } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
  })

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="w-full flex justify-between">
          {data?.find((u) => u.id == value)?.name || "Select a unit"}
          <ChevronDown className="opacity-50 stroke-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)]">
        <Command>
          <CommandInput placeholder="Search units..." />
          <CommandList>
            <CommandEmpty>No units found.</CommandEmpty>
            <CommandGroup>
              {data?.map((u) => (
                <CommandItem
                  value={u.name}
                  key={u.id}
                  onSelect={() => {
                    setOpen(false)
                    onChange(u.id)
                  }}
                >
                  {u.name}
                  <Check className={cn("ml-auto ", u.id == value ? "opacity-100" : "opacity-0")} />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
